"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloudOrder = require("@/api/operationManagement/cloudOrder");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CloudOrder',
  data: function data() {
    return {
      loading: false,
      saveLoading: false,
      form: {
        appKey: '',
        appSecret: '',
        agentCode: '',
        pageLink: '',
        materialLink: ''
      },
      rules: {
        appKey: [{
          required: true,
          message: '请输入云发单AppKey',
          trigger: 'blur'
        }],
        appSecret: [{
          required: true,
          message: '请输入云发单AppSecret',
          trigger: 'blur'
        }],
        agentCode: [{
          required: true,
          message: '请输入云发单Agentcode',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getConfig();
  },
  methods: {
    getConfig: function getConfig() {
      var _this = this;
      this.loading = true;
      (0, _cloudOrder.getCloudOrderConfig)().then(function (res) {
        var config = res.data && res.data.config || {};
        _this.form = {
          appKey: config.appKey || '',
          appSecret: config.appSecret || '',
          agentCode: config.agentCode || '',
          pageLink: config.pageLink || '',
          materialLink: config.materialLink || ''
        };
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSave: function handleSave() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.$confirm('确认保存云发单配置？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.saveLoading = true;
            var config = {
              appKey: _this2.form.appKey,
              appSecret: _this2.form.appSecret,
              agentCode: _this2.form.agentCode
            };
            (0, _cloudOrder.saveCloudOrderConfig)(config).then(function () {
              _this2.$notify.success({
                title: '温馨提示',
                message: '保存成功'
              });
              _this2.getConfig();
            }).finally(function () {
              _this2.saveLoading = false;
            });
          }).catch(function () {});
        }
      });
    },
    handleReset: function handleReset() {
      this.$refs.form.resetFields();
    },
    handleCopy: function handleCopy(text) {
      var _this3 = this;
      navigator.clipboard.writeText(text).then(function () {
        _this3.$message.success('复制成功');
      }).catch(function () {
        _this3.$message.error('复制失败，请手动复制');
      });
    }
  }
};